var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dataReady
    ? _c("div", [
        _c(
          "div",
          { attrs: { id: "gridPrincipal" } },
          _vm._l(_vm.filtrarElemento(_vm.graficosData), function(dash) {
            return _c(
              "v-card",
              { key: dash.namekey, staticClass: "elemento" },
              [
                _c(
                  "v-card",
                  {
                    staticClass: "card",
                    attrs: { elevation: "2", loading: true }
                  },
                  [
                    _c("v-card-title", [
                      _c("h3", [
                        _vm._v(
                          "\n            " + _vm._s(dash.name) + "\n          "
                        )
                      ])
                    ]),
                    _c("v-divider", { staticClass: "mx-4" }),
                    _c("br"),
                    dash.tipo_grafico == "barra"
                      ? _c(
                          "div",
                          { staticClass: "pa-3" },
                          [
                            _c("GraficoBarra", { attrs: { dataInicial: dash } })
                          ],
                          1
                        )
                      : _vm._e(),
                    dash.tipo_grafico == "barra_stacked"
                      ? _c(
                          "div",
                          { staticClass: "pa-3" },
                          [
                            _c("GraficoBarraStacked", {
                              attrs: { dataInicial: dash }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    dash.tipo_grafico == "barra_laterial"
                      ? _c(
                          "div",
                          { staticClass: "pa-3" },
                          [
                            _c("GraficoBarraLateral", {
                              attrs: { dataInicial: dash }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    dash.tipo_grafico == "pie"
                      ? _c(
                          "div",
                          { staticClass: "pa-3" },
                          [_c("GraficoPie", { attrs: { dataInicial: dash } })],
                          1
                        )
                      : _vm._e(),
                    dash.tipo_grafico == "tabla"
                      ? _c(
                          "div",
                          { staticClass: "pa-3" },
                          [_c("GraficoGrid", { attrs: { dataInicial: dash } })],
                          1
                        )
                      : _vm._e(),
                    dash.tipo_grafico == "mapa"
                      ? _c(
                          "div",
                          { staticClass: "pa-3" },
                          [_c("GraficoMapa", { attrs: { dataInicial: dash } })],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          }),
          1
        ),
        _c(
          "div",
          { attrs: { id: "gridSecundario" } },
          _vm._l(_vm.filtrarTabla(this.graficosData), function(dash) {
            return _c(
              "div",
              { key: dash.namekey, staticClass: "elemento" },
              [
                _c(
                  "v-card",
                  {
                    staticClass: "card mt-3",
                    attrs: { elevation: "2", loading: true }
                  },
                  [
                    _c("v-card-title", [
                      _c("h3", [
                        _vm._v(
                          "\n            " + _vm._s(dash.name) + "\n          "
                        )
                      ])
                    ]),
                    _c("v-divider", { staticClass: "mx-4" }),
                    _c("br"),
                    dash.tipo_grafico == "tabla"
                      ? _c(
                          "div",
                          { staticClass: "pa-3" },
                          [_c("GraficoGrid", { attrs: { dataInicial: dash } })],
                          1
                        )
                      : _vm._e(),
                    dash.tipo_grafico == "barra_lateral"
                      ? _c(
                          "div",
                          { staticClass: "pa-3" },
                          [
                            _c("GraficoBarraLateralStaked", {
                              attrs: { dataInicial: dash }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          }),
          0
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }